var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0811 30.2156L9.34063 36.7129L2.97939 36.8475C1.07832 33.3214 0 29.2871 0 25C0 20.8544 1.0082 16.945 2.79531 13.5027H2.79668L8.45996 14.541L10.9408 20.1703C10.4216 21.6841 10.1386 23.3091 10.1386 25C10.1388 26.8352 10.4712 28.5935 11.0811 30.2156Z",
    fill: "#FBBB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5634 20.3297C49.8505 21.842 50.0002 23.4038 50.0002 25C50.0002 26.7899 49.812 28.5358 49.4535 30.2198C48.2365 35.9506 45.0565 40.9547 40.6514 44.4959L40.65 44.4946L33.5168 44.1306L32.5072 37.8283C35.4303 36.1141 37.7146 33.4314 38.918 30.2198H25.5498V20.3297H49.5634Z",
    fill: "#518EF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6498 44.4946L40.6512 44.4959C36.3669 47.9396 30.9245 50 25.0001 50C15.4795 50 7.20205 44.6787 2.97949 36.8476L11.0812 30.2158C13.1924 35.8503 18.6278 39.8614 25.0001 39.8614C27.7391 39.8614 30.3051 39.1209 32.5069 37.8284L40.6498 44.4946Z",
    fill: "#28B446"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9575 5.75547L32.8586 12.3859C30.5798 10.9615 27.886 10.1387 25.0001 10.1387C18.4836 10.1387 12.9465 14.3337 10.941 20.1703L2.79678 13.5027H2.79541C6.95615 5.48076 15.338 0 25.0001 0C31.066 0 36.6278 2.16074 40.9575 5.75547Z",
    fill: "#F14336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.7506d37346ee6763cee25ae8e2ec30c9.svg";
export { ForwardRef as ReactComponent };